import { useMutation } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'

type SelfServiceCampaignGooglePayload = {
  campaign_ids: Array<any>
  agency_id?: string
  vendor_id: number
  customer_account_id: string
  login_customer_id: string
  account_name: string
}

type SelfServiceCampaignFacebookPayload = {
  campaign_ids: Array<any>
  agency_id?: string
  vendor_id: number
  account_id: string
  account_name: string
}

type Payload = {
  Google: SelfServiceCampaignGooglePayload
  Facebook: SelfServiceCampaignFacebookPayload
}

export const useSaveSelfServiceCampaign = <T extends keyof Payload>() => {
  const dealership = useDealership()
  return useMutation(({ data }: { data: Payload[T] }) =>
    request({
      url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/self-service/import`,
      method: 'POST',
      data,
    }),
  )
}
